import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Card, CardContent } from '@material-ui/core';
import Linkify from '../../Linkify';

const TextAnswer = ({ textAnswerTodisplay }) => {
  const useStyles = makeStyles( theme => ({
    textAnswerCard: {
      width: '383px',
      background: '#F4F4F4',
      borderRadius: '0px 4px 4px 0px',
      color: '#666666',
      position: 'relative',
      margin: '10px 0px 10px 0px',
      overflow: 'auto',
      borderColor: '#F4F4F4',
      [theme.breakpoints.down('md')]: {
        width: '138px'
      }
    },
    text: {
      position: 'absolute',
      margin: '10px',
      fontSize: '12px'
    }
  }));

  const classes = useStyles();

  return (
    <Card className = { classes.textAnswerCard } variant = { 'outlined' }>
      <CardContent className = { classes.text }>
        <Linkify>
          {textAnswerTodisplay}
        </Linkify>
      </CardContent>
    </Card>
  );
};

export default TextAnswer;
